import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';


@Injectable()
export class DataTableService {
  private subject = new Subject<any>();

  toggle(message: string) {
    this.subject.next({text: message});
  }

  detectChanges(): Observable<any> {
    return this.subject.asObservable();
  }
}
